import React from 'react';
import { motion } from 'framer-motion';
import { useLanguage } from '../context/LanguageContext';

const Hero = () => {
  const { t } = useLanguage();
  
  const containerVariants = {
    hidden: { opacity: 0 },
    visible: {
      opacity: 1,
      transition: {
        staggerChildren: 0.2,
        delayChildren: 0.3
      }
    }
  };

  const itemVariants = {
    hidden: { opacity: 0, y: 20 },
    visible: { opacity: 1, y: 0, transition: { duration: 0.8, ease: [0.16, 1, 0.3, 1] } }
  };

  const TIDYCAL_URL = "https://tidycal.com/mathiasdeppe/free-15-minute-growth-review";

  return (
    <section className="relative min-h-screen flex items-center justify-center px-6 pt-24 overflow-hidden bg-zinc-950">
      <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[800px] h-[800px] bg-orange-500/10 rounded-full blur-[120px] pointer-events-none" />

      <motion.div 
        variants={containerVariants}
        initial="hidden"
        animate="visible"
        className="relative z-10 max-w-5xl mx-auto text-center flex flex-col items-center"
      >
        <motion.h1 
          variants={itemVariants}
          className="text-4xl md:text-6xl lg:text-7xl font-extrabold text-white tracking-tight leading-[1.1] mb-6"
        >
          {t.hero.h1} <br className="hidden md:block" />
          <span className="text-transparent bg-clip-text bg-gradient-to-r from-orange-400 to-orange-600">
            {t.hero.h1Span}
          </span>
        </motion.h1>

        <motion.h2 
          variants={itemVariants}
          className="text-xl md:text-2xl font-medium text-zinc-300 mb-6 max-w-3xl leading-relaxed"
        >
          {t.hero.h2}
        </motion.h2>

        <motion.p 
          variants={itemVariants}
          className="text-base md:text-lg text-zinc-400 mb-10 max-w-2xl leading-relaxed"
        >
          {t.hero.p}
        </motion.p>

        <motion.div variants={itemVariants}>
          <a 
            href={TIDYCAL_URL}
            target="_blank"
            rel="noopener noreferrer"
            className="group relative inline-flex items-center justify-center px-8 py-4 text-lg font-bold text-white bg-orange-500 rounded-full overflow-hidden transition-all hover:scale-105 hover:bg-orange-600 hover:shadow-[0_0_40px_rgba(249,115,22,0.4)]"
          >
            <span className="mr-2 transition-transform group-hover:translate-x-1">→</span>
            {t.hero.cta}
          </a>
        </motion.div>
      </motion.div>
    </section>
  );
};

export default Hero;